<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          outlined
          x-small
          fab
          dark
          class="purple"
          @click="linkGroupAndAnimateur(groupe)"
        >
          <v-icon>mdi-account-convert</v-icon>
        </v-btn>
      </template>
      <span>Changer d'animateur</span>
    </v-tooltip>

    <v-dialog
      v-model="dialog"
      persistent
      :overlay="false"
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title primary-title>
          {{ groupe.nom_groupe }}
        </v-card-title>
        <v-card-text>
          <v-container grid-list-xs>
            <v-row>
              <v-col>
                <v-autocomplete
                  :items="animateurs"
                  v-model="animateurSelectionne"
                  label="Animateur"
                  outlined
                  return-object
                  item-text="displayName"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-container> </v-card-text
        ><v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded color="warning" @click="closeDialog()">Annuler</v-btn>
          <v-btn rounded color="success" @click="savelinked()"
            >Sauvegarder</v-btn
          ></v-card-actions
        >
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  mounted() {
    //this.getAnimateurs();
  },
  props: {
    groupe: {
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      animateurSelectionne: {},
    };
  },
  methods: {
    linkGroupAndAnimateur(groupe) {
      this.dialog = true;
    },
 
    savelinked() {
      let self = this;
      // console.log(this.animateurSelectionne);
      // console.log(this.groupe);
      console.log("****savelinked before batch", self.groupe.id);

      // Get a new write batch
      var batch = this.$firebase.firestore().batch();
      var objet = {
        nom_responsable: self.animateurSelectionne.displayName,
        responsable: self.animateurSelectionne.uid,
        date_updated: self.$moment(Date.now()).format("YYYY-MM-DD HH:mm:ss"),
        modifier_user_name: self.user.displayName,
        modifier_user_id: self.user.uid,
      };
      console.log("???????????", objet);
      batch.set(
        this.$firebase.firestore().collection("groupes").doc(self.groupe.id),
        objet,
        { merge: true }
      );
      this.$store.commit("Loading/START_BUSY_STATE", "batch modif groupe", {
        root: true,
      });
      // Commit the batch
      batch
        .commit()
        .then(() => {
          console.log("modifications terminées dans groupe");

          /** update membres */
          const MEMBRES = self.$firebase.firestore().collection("membres");

          MEMBRES.where("id_groupe", "==", self.groupe.id)
            .get()
            .then((snapshots) => {
              console.log("membres successfully updated!");
              if (snapshots.size > 0) {
                snapshots.forEach((snap) => {
                  MEMBRES.doc(snap.id).set(
                    {
                      nom_responsable: self.animateurSelectionne.displayName,
                      id_responsable: self.animateurSelectionne.uid,
                    },
                    { merge: true }
                  );
                });
              } else {
                console.log("no snap membres");
              }
            });
          /** END update membres */





          /** update etapes_effectives */
          const etapes_effectives = self.$firebase
            .firestore()
            .collection("etapes_effectives");
          etapes_effectives
            .where("groupes_id_groupe", "==", self.groupe.id)
            .get()
            .then((snapshots) => {
              console.log("Etapes effectives successfully updated!");
              if (snapshots.size > 0) {
                snapshots.forEach((snap) => {
                  etapes_effectives.doc(snap.id).set(
                    {
                      nom_responsable: self.animateurSelectionne.displayName,
                      id_responsable: self.animateurSelectionne.uid,
                    },
                    { merge: true }
                  );
                });
              } else {
                console.log("no snap Etapes effectives");
              }
            });
          /** End update etapes_effectives */
          /** update parcours_effectif */
          const parcours_effectif = self.$firebase
            .firestore()
            .collection("parcours_effectif");
          parcours_effectif
            .where("groupes_id_groupe", "==", self.groupe.id)
            .get()
            .then((snapshots) => {
              if (snapshots.size > 0) {
                console.log("Parcours Effectifs successfully updated!");
                snapshots.forEach((snap) => {
                  parcours_effectif.doc(snap.id).set(
                    {
                      nom_responsable: self.animateurSelectionne.displayName,
                      id_responsable: self.animateurSelectionne.uid,
                    },
                    { merge: true }
                  );
                });
              } else {
                console.log("no snap Parcours Effectifs");
              }
            });
          /** End update parcours_effectif */
          /** update dotationsDeGroupe */
          const dotationsDeGroupe = self.$firebase
            .firestore()
            .collection("dotationsDeGroupe");
          dotationsDeGroupe
            .where("groupes_code_groupe", "==", self.groupe.id)
            .get()
            .then((snapshots) => {
              if (snapshots.size > 0) {
                console.log("Dotations successfully updated!");
                snapshots.forEach((snap) => {
                  dotationsDeGroupe.doc(snap.id).set(
                    {
                      nom_responsable: self.animateurSelectionne.displayName,
                      responsable: self.animateurSelectionne.uid,
                    },
                    { merge: true }
                  );
                });
              } else {
                console.log("no snap Dotations");
              }
            });
          /** END update dotationsDeGroupe */
         
         
          /** update formationsDeGroupe */
          const formationsDeGroupe = self.$firebase
            .firestore()
            .collection("formationsDeGroupe");
          formationsDeGroupe
            .where("groupes_code_groupe", "==", self.groupe.id)
            .get()
            .then((snapshots) => {
              console.log("Formations de Groupe successfully updated!");
              if (snapshots.size > 0) {
                snapshots.forEach((snap) => {
                  formationsDeGroupe.doc(snap.id).set(
                    {
                      nom_responsable: self.animateurSelectionne.displayName,
                      responsable: self.animateurSelectionne.uid,
                    },
                    { merge: true }
                  );
                });
              } else {
                console.log("no snap formationsDeGroupe");
              }
            });
          /** End update formationsDeGroupe */

          /** update presencesFormationsGroupes */
          const presencesFormationsGroupes = self.$firebase
            .firestore()
            .collection("presencesFormationsGroupes");
          presencesFormationsGroupes
            .where("groupes_id_groupe", "==", self.groupe.id)
            .get()
            .then((snapshots) => {
              console.log(
                "Presences Formations De groupe successfully updated!"
              );
              if (snapshots.size > 0) {
                snapshots.forEach((snap) => {
                  presencesFormationsGroupes.doc(snap.id).set(
                    {
                      nom_responsable: self.animateurSelectionne.displayName,
                      id_responsable: self.animateurSelectionne.uid,
                    },
                    { merge: true }
                  );
                });
              } else {
                console.log("no snap presencesFormationsGroupes");
              }
            });
          /** End update presencesFormationsGroupes */

          /** update presencesDotationsGroupes */
          const presencesDotationsGroupes = self.$firebase
            .firestore()
            .collection("presencesDotationsGroupes");
          presencesDotationsGroupes
            .where("groupes_id_groupe", "==", self.groupe.id)
            .get()
            .then((snapshots) => {
              console.log(
                "Presences Dotations De groupe successfully updated!"
              );
              if (snapshots.size > 0) {
                snapshots.forEach((snap) => {
                  presencesDotationsGroupes.doc(snap.id).set(
                    {
                      nom_responsable: self.animateurSelectionne.displayName,
                      id_responsable: self.animateurSelectionne.uid,
                    },
                    { merge: true }
                  );
                });
              } else {
                console.log("no snap presencesDotationsGroupes");
              }
            });
          /** End update presencesDotationsGroupes */
          
          /** update fiches */
          const fiches = self.$firebase.firestore().collection("fiches");
          fiches
            .where("groupes_id_groupe", "==", self.groupe.id)
            .get()
            .then((snapshots) => {
              console.log("fiches successfully updated!");
              if (snapshots.size > 0) {
                snapshots.forEach((snap) => {
                  fiches.doc(snap.id).set(
                    {
                      nom_responsable: self.animateurSelectionne.displayName,
                      id_responsable: self.animateurSelectionne.uid,
                    },
                    { merge: true }
                  );
                });
              } else {
                console.log("no snap fiches");
              }
            });
          /** End update fiches */


          this.$emit("reloadAfficher");
        })
        .then(() => {
          this.$store.commit("Loading/END_BUSY_STATE", "batch modif groupe", {
            root: true,
          });
        });

      this.dialog = false;
    },
    closeDialog(groupe) {
      this.dialog = false;
    },
    ...mapActions({
      getAnimateurs: "Users/getAnimateurs",
      GetGroupesDeRegions: "Groupes/GetGroupesDeRegions",
     
    }),
  },
  computed: {
    ...mapState({
      animateurs: (state) => state.Users.animateursDeRegions,
      regionSupervisees: (state) => state.Utils.listeRegionsSupervisees,
      user: (state) => state.Auth.user,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
